import Dexie, { type Table } from 'dexie'
import type { EmailHtmlRow } from '~/features/email-html-cache/storage/types'
import type {
    AsyncQueueItemRow,
    AsyncQueueStateRow,
} from '~/features/async-queue/types'

export class LocalDexieDB extends Dexie {
    emailHtml!: Table<EmailHtmlRow, string>
    asyncQueueItems!: Table<AsyncQueueItemRow, [string, string]>
    asyncQueueStates!: Table<AsyncQueueStateRow, string>

    constructor() {
        super('taxing-local')
        this.version(1).stores({
            // Primary key is externalId
            emailHtml: 'externalId',
        })
        this.version(2).stores({
            asyncQueueStates: 'id',
            asyncQueueItems: '[queueId+id], queueId',
        })

        this.version(3).stores({
            asyncQueueStates: null,
        })

        this.version(4).stores({
            asyncQueueStates: 'queueId',
        })
    }
}
